module.exports = __webpack_public_path__ + "static/media/designPatent_30-1013203.a75169b9.png";